import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
import { StarIcon, CopilotIcon } from '@primer/octicons-react';
import { PropTableValues } from '../../src/components';
import { EyebrowBannerIconColors, EyebrowBannerLabelColors } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {EyebrowBanner} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <p>{`This is the default variant for the eyebrow banner component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<EyebrowBanner href="http://githubuniverse.com">
  <EyebrowBanner.Visual>
    <img
      src="https://github.githubassets.com/assets/eyebrow-23@2x-563f292d9e30.png"
      alt="Badge featuring a GitHub logo surrounded by Universe-themed shapes"
    />
  </EyebrowBanner.Visual>
  <EyebrowBanner.Heading>
    GitHub Universe: Dive in to AI, security, and DevEx
  </EyebrowBanner.Heading>
  <EyebrowBanner.SubHeading>
    Get your tickets now to join us on Nov. 8-9.
  </EyebrowBanner.SubHeading>
</EyebrowBanner>
`}</code></pre>
    <h3>{`Color modes`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` to automatically adjust the visual presentation of the component to light or dark variants.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack gap="none" padding="none">
  <ThemeProvider colorMode="light">
    <Box
      backgroundColor="default"
      padding="normal"
      borderWidth="thin"
      borderStyle="solid"
      borderColor="default"
    >
      <EyebrowBanner href="http://githubuniverse.com">
        <EyebrowBanner.Visual>
          <img
            src="https://github.githubassets.com/assets/eyebrow-23@2x-563f292d9e30.png"
            alt="Badge featuring a GitHub logo surrounded by Universe-themed shapes"
          />
        </EyebrowBanner.Visual>
        <EyebrowBanner.Heading>
          GitHub Universe: Dive in to AI, security, and DevEx
        </EyebrowBanner.Heading>
        <EyebrowBanner.SubHeading>
          Get your tickets now to join us on Nov. 8-9.
        </EyebrowBanner.SubHeading>
      </EyebrowBanner>
    </Box>
  </ThemeProvider>
  <ThemeProvider colorMode="dark">
    <Box backgroundColor="default" padding="normal">
      <EyebrowBanner href="http://githubuniverse.com">
        <EyebrowBanner.Visual>
          <img
            src="https://github.githubassets.com/assets/eyebrow-23@2x-563f292d9e30.png"
            alt="Badge featuring a GitHub logo surrounded by Universe-themed shapes"
          />
        </EyebrowBanner.Visual>
        <EyebrowBanner.Heading>
          GitHub Universe: Dive in to AI, security, and DevEx
        </EyebrowBanner.Heading>
        <EyebrowBanner.SubHeading>
          Get your tickets now to join us on Nov. 8-9.
        </EyebrowBanner.SubHeading>
      </EyebrowBanner>
    </Box>
  </ThemeProvider>
</Stack>
`}</code></pre>
    <h3>{`Text labels`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`EyebrowBanner.Label`}</inlineCode>{` to display a leading text for additional context.`}</p>
    <p>{`A `}<inlineCode parentName="p">{`color`}</inlineCode>{` prop is available to customise the color of the label.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack>
  <EyebrowBanner href="http://githubuniverse.com">
    <EyebrowBanner.Label>NEW</EyebrowBanner.Label>
    <EyebrowBanner.Heading>
      GitHub Copilot now available for Business
    </EyebrowBanner.Heading>
  </EyebrowBanner>
  <EyebrowBanner href="http://githubuniverse.com">
    <EyebrowBanner.Label color="blue-purple">NEW</EyebrowBanner.Label>
    <EyebrowBanner.Heading>
      GitHub Copilot now available for Business
    </EyebrowBanner.Heading>
  </EyebrowBanner>
  <EyebrowBanner href="http://githubuniverse.com">
    <EyebrowBanner.Label color="red">NEW</EyebrowBanner.Label>
    <EyebrowBanner.Heading>
      GitHub Copilot now available for Business
    </EyebrowBanner.Heading>
  </EyebrowBanner>
</Stack>
`}</code></pre>
    <h3>{`Icon visuals`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`EyebrowBanner.Visual`}</inlineCode>{` with an `}<inlineCode parentName="p">{`icon`}</inlineCode>{` prop to display a leading icon for additional context.`}</p>
    <p>{`Icons can be SVGs or ideally Octicons. If using Octicons, import the icon from `}<inlineCode parentName="p">{`@primer/octicons-react`}</inlineCode>{` and pass it as the `}<inlineCode parentName="p">{`icon`}</inlineCode>{` prop.`}</p>
    <p>{`A `}<inlineCode parentName="p">{`color`}</inlineCode>{` option is available to customise the color of the icon.`}</p>
    <p>{`An optional `}<inlineCode parentName="p">{`hasBackground`}</inlineCode>{` prop can be used to fill the surrounding circle with the lighter hue of the selected color.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack>
  <EyebrowBanner href="/">
    <EyebrowBanner.Visual icon={StarIcon} color="blue" hasBackground />
    <EyebrowBanner.Heading>
      GitHub Universe: Dive in to AI, security, and DevEx
    </EyebrowBanner.Heading>
    <EyebrowBanner.SubHeading>
      Get your tickets now to join us on Nov. 8-9.
    </EyebrowBanner.SubHeading>
  </EyebrowBanner>
  <EyebrowBanner href="/">
    <EyebrowBanner.Visual icon={CopilotIcon} color="blue" />
    <EyebrowBanner.Heading>
      GitHub Copilot now available for Business
    </EyebrowBanner.Heading>
  </EyebrowBanner>
</Stack>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`EyebrowBanner `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`href`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The URL that the eyebrow banner points to`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`EyebrowBanner.Heading `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p>{`Please note that this is not a HTML-based heading element.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The primary messaging that appears on the top-most line`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`EyebrowBanner.SubHeading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optional secondary messaging that appears beneath the heading`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`EyebrowBanner.Visual`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[`ReactNode`, `IconProps`]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optional icon. Accepts React-based Octicons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`color`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[...EyebrowBannerIconColors]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optional icon color.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`hasBackground`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optional background color.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Accepts `}<inlineCode parentName="td">{`img`}</inlineCode>{`, `}<inlineCode parentName="td">{`picture`}</inlineCode>{` or `}<inlineCode parentName="td">{`svg`}</inlineCode>{` elements`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`EyebrowBanner.Label`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`color`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[...EyebrowBannerLabelColors]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optional label color.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Text to appear in the label slot`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      